import ExpandableParagraph from './ExpandableParagraph';

export default ExpandableParagraph;
